











import Vue from 'vue';
import Component from 'vue-class-component';
import IdleInterval from '@/lib/util/IdleInterval';
import Lockr from 'lockr';
import ServiceWorkerManager from '@/lib/util/ServiceWorkerManager';
import UTCTimestamp from '@/lib/common/objects/UTCTimestamp';
import VersionNumber from '@/lib/util/VersionNumber';
import { api } from '@/lib/KioskRestApi';
import { kioskSetup } from '@/lib/KioskSetup';
import { $nav } from '@/lib/KioskNavigation';
import { version } from '@/version';
import { IS_LOCALHOST } from '@/lib/common/IsLocalhost';

const EVERY_MINUTE_MS = 60 * 1000;
const EVERY_HOUR_MS = 60 * 60 * 1000;

@Component
export default class App extends Vue {

  // reactive properties
  isUpdateAvailable: boolean = false;

  // non-reactive properties
  private count: number = 1;
  private lastClickTimestamp: UTCTimestamp = new UTCTimestamp();

  // lifecycle hooks
  created() {
    const workerManager = ServiceWorkerManager.instance();
    workerManager.addOnWaitingWorkerListener((waitingWorker: ServiceWorker | null) => {
      this.isUpdateAvailable = (waitingWorker === null) ? false : true;
    });
    this.installUpdateMonitor(workerManager);
  }

  // generated
  get kioskId() {
    return kioskSetup.kioskId.getId();
  }

  // methods
  onClickVersion() {
    const now = new UTCTimestamp();
    if ( (now.toSeconds() - this.lastClickTimestamp.toSeconds()) > 1 ) {
      this.count = 1;
      //console.log(`tap=${this.count}`);
    }
    else {
      this.count += 1;
      //console.log(`tap=${this.count}`);
    }
    this.lastClickTimestamp = now;
    if ( this.count > 20 || (IS_LOCALHOST && this.count > 1) ) {
      this.count = 1;
      if ( '/setup' !== this.$route.path ) {
        $nav.to(this, '/setup');
      }
    }
  }

  installUpdateMonitor(workerManager: ServiceWorkerManager) {
    const UPDATE_FREQUENCY_MS =  Lockr.get('kb_isAutoUpdateEveryMinute', false) ? EVERY_MINUTE_MS : EVERY_HOUR_MS;
    const minutes = UPDATE_FREQUENCY_MS / 60000;
    console.log('  `--> install software update monitor to check server for updates every ' + minutes + ' minutes');
    new IdleInterval(UPDATE_FREQUENCY_MS, async () => {
      console.log("check server for new software version");
      try {
        const serverVers = await api.getServerVersionNumber();
        const localVers = new VersionNumber(version);
        console.log("  `--> server version = " + serverVers);
        console.log("  `--> local version = " + localVers);
        const relativeOrder = localVers.compareTo(serverVers);
        if ( relativeOrder < 0 ) {
          console.log("  `--> will instruct service workers to check for update");
          workerManager.checkForUpdate()
          .then((isUpdateFound: boolean) => {
            if ( isUpdateFound ) {
              setTimeout(() => {
                workerManager.activateWaitingWorker();
              }, 3000);
            }
          })
          .catch((err) => {
            console.log("  `--> failed to get service worker to check for update");
            this.isUpdateAvailable = true; // at least mark the screen that update is available
          });
        }
      }
      catch (error) {
        console.log("  `--> Error: ", error);
      }
    }).reset();
  }

}
